import React from 'react';

export type FreeBadgeSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<FreeBadgeSize, string> = {
  sm:
    'min-h-[1.35rem] rounded-md px-2 py-px text-[10px] font-bold leading-none tracking-[0.04em] sm:min-h-[1.45rem] sm:px-2.5 sm:text-[11px]',
  md: 'min-h-[1.625rem] rounded-lg px-2.5 py-1 text-xs font-extrabold leading-none tracking-wide sm:min-h-[1.75rem] sm:text-[13px]',
  lg:
    'min-h-[2rem] rounded-xl px-3 py-1.5 text-sm font-black leading-none tracking-wide shadow-sm sm:min-h-[2.25rem] sm:px-3.5 sm:text-base sm:tracking-[0.02em]',
};

/**
 * برچسب «رایگان» — مینیمال، خوانا، هم‌سو با تم آبی محصول (#1C3B9B) با لهجهٔ زمردی ملایم.
 */
export const FreeBadge: React.FC<{
  size?: FreeBadgeSize;
  /** برای تراز کنار متن هم‌خط */
  className?: string;
}> = ({ size = 'md', className = '' }) => {
  const base =
    'inline-flex max-w-max items-center justify-center whitespace-nowrap text-emerald-900 ' +
    'border border-emerald-200/95 bg-[linear-gradient(165deg,#f0fdf4_0%,#ecfdf5_45%,#f8fafc_100%)] ' +
    'shadow-[inset_0_1px_0_0_rgba(255,255,255,0.92)] ring-1 ring-[#1C3B9B]/[0.07] backdrop-blur-[2px] ' +
    'transition-[transform,box-shadow] duration-200 hover:shadow-[inset_0_1px_0_0_rgba(255,255,255,0.92),0_8px_20px_-12px_rgba(16,185,129,0.35)]';

  return (
    <span
      className={`${base} ${sizeClasses[size]} ${className}`.trim()}
      dir="rtl"
      aria-label="رایگان"
    >
      رایگان
    </span>
  );
};
